import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { collection, onSnapshot, query } from '@firebase/firestore';
import { Unsubscribe } from '@firebase/util';
import { Subject } from 'rxjs';
import { LoadingService } from '../loading.service';
import { BooksService } from './books.service';
import { Testimonial } from './testimonial';
import { BOOKS_COLLECTION, BOOK_CONSTANTS, TESTIMONIALS_COLLECTION } from './book.constants';

@Injectable({
  providedIn: 'root'
})
export class TestimonialsService {

  constructor(public firestore: AngularFirestore, public loadingService: LoadingService, private booksService: BooksService) { }

  addingNewTestimonial = false
  editingTestimonialUid?: string
  db = this.firestore.firestore
  private listener?: Unsubscribe
  private watchedBookUid?: string
  private allTestimonials = new Subject<Testimonial[]>();
  public allTestimonials$ = this.allTestimonials.asObservable();

  watchTestimonials(bookUid: string) {
    if (this.watchedBookUid === bookUid && this.listener != null) {
      return
    }
    this.stopWatching()
    this.watchedBookUid = bookUid

    const q = query(collection(this.db, BOOKS_COLLECTION, bookUid, TESTIMONIALS_COLLECTION));
    this.listener = onSnapshot(q, (querySnapshot) => {
      const snapshotTestimonials: Testimonial[] = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        const uid = doc.id
        const reviewerName = data["reviewerName"]
        const reviewerTitle = data["reviewerTitle"]
        const quote = data["quote"]

        const testimonial = { uid, bookUID: bookUid, reviewerName, reviewerTitle, quote } as Testimonial
        snapshotTestimonials.push(testimonial)
      });
      snapshotTestimonials.sort((a, b) => a.reviewerName < b.reviewerName ? -1 : 1);
      this.allTestimonials.next(snapshotTestimonials)
    },
      (error) => {
        alert(error)
        throw (error)
      });
  }

  stopWatching() {
    if (this.listener != null) {
      this.listener()
      this.listener = undefined
    }
    this.watchedBookUid = undefined
    this.allTestimonials.next([])
    this.addingNewTestimonial = false
    this.editingTestimonialUid = undefined
  }

  async addNewTestimonial(bookUid: string, testimonial: Testimonial, loadingKey: string) {
    const docRef = this.db.collection(BOOKS_COLLECTION).doc(bookUid).collection(TESTIMONIALS_COLLECTION).doc();
    const payload = Object(testimonial)

    delete payload.uid
    delete payload.bookUID
    payload["dateAdded"] = new Date()

    docRef.set(payload)
      .then(response => {
        this.loadingService.removeLoadingKey(loadingKey)
        this.addingNewTestimonial = false
        this.booksService.keepFocus = false
        alert(BOOK_CONSTANTS.TESTIMONIAL_ADDED)
      })
      .catch(e => {
        this.loadingService.removeLoadingKey(loadingKey)
        alert(e)
        throw (e)
      });
  }

  async updateTestimonial(bookUid: string, testimonial: Testimonial) {
    const loadingKey = testimonial.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const docRef = this.db.collection(BOOKS_COLLECTION).doc(bookUid).collection(TESTIMONIALS_COLLECTION).doc(testimonial.uid);

    const payload = Object(testimonial)
    delete payload.uid
    delete payload.bookUID

    docRef.update(payload)
      .then(response => {
        this.loadingService.removeLoadingKey(loadingKey)
        this.editingTestimonialUid = undefined
        this.booksService.keepFocus = false
        alert(BOOK_CONSTANTS.TESTIMONIAL_UPDATED)
      })
      .catch(e => {
        this.loadingService.removeLoadingKey(loadingKey)
        alert(e)
        throw (e)
      });
  }

  async deleteTestimonial(bookUid: string, testimonial: Testimonial) {
    const loadingKey = testimonial.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const docRef = this.db.collection(BOOKS_COLLECTION).doc(bookUid).collection(TESTIMONIALS_COLLECTION).doc(testimonial.uid);

    docRef.delete()
      .then(response => {
        this.loadingService.removeLoadingKey(loadingKey)
        alert(BOOK_CONSTANTS.TESTIMONIAL_REMOVED)
      })
      .catch(e => {
        this.loadingService.removeLoadingKey(loadingKey)
        alert(e)
        throw (e)
      });
  }
}
